import { createContext } from 'react';
import * as React from 'react';

let listId: string | undefined;

export const ListId = createContext<string | undefined>(
  window.specificListData?.component,
);

export function getListId() {
  if (!listId) throw new Error('There is no admin id');
  return listId;
}

const ListIdContextProvider = ({
  children,
  id,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  listId = id;

  return <ListId.Provider value={id}>{children}</ListId.Provider>;
};

export default ListIdContextProvider;
